export default __webpack_public_path__ + "static/media/dialog_logo.e32c0932.svg";